import { lazy } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import "./style/style.scss";

const App = lazy(() => import("./app/components/App/App"));

const baseName =
  import.meta.env.BASE_URL === "./" || import.meta.env.BASE_URL === "."
    ? ""
    : import.meta.env.BASE_URL;

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <HelmetProvider>
        <Router basename={baseName}>
          <App />
        </Router>
      </HelmetProvider>
    </Provider>,
  );
} else {
  console.error("Root element not found");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
